import { k } from "../kaplay";

import { attack } from "./attack";
import { properties } from "../data/properties";

export function swords(){
  return {
    id: "swords",
    add(){
      this.setSwordNumber(1);
    },
    setSwordNumber(number){
      properties.sword.number = number;
      k.get("sword").forEach((s) => s.destroy());

      let angle = 360 / properties.sword.number;
      for(let i = 0; i < properties.sword.number; i++){
        const newSword = k.add([
          "sword",
          "attack_enemy",

          k.sprite("sword"),
          k.pos(k.center()),
          k.anchor("bot"),
          k.area(),
          k.layer("foreground"),
          k.scale(properties.sword.scale),
          k.rotate(),
          attack({ damage: properties.sword.damage }),
        ])
        newSword.angle = angle * i;
      }
    },
    update() {
      k.get("sword").forEach((sword) => {
        const dist = 60; // distance du centre du joueur (rayon du cercle)
        const rad = (sword.angle - 90) * Math.PI / 180;
  
        // Position absolue par rapport au joueur, on peut ajouter un offset
        sword.pos.x = k.center().x + Math.cos(rad) * dist;
        sword.pos.y = k.center().y + Math.sin(rad) * dist;
  
        sword.angle += properties.sword.rotSpeed;
      })
    },
    destroy(){
      k.get("sword").forEach((s) => {
        if (s) s.destroy();
      });
    }
  }
}